module.exports = __webpack_public_path__ + "static/media/vu.89beef37.svg";